import axios from 'axios'

type DiamondResponse = {
  product_id: number
  variant_id: number
}

export const createDiamondProduct = async (
  id: string,
  token: string | undefined
) => {
  const options = {
    method: 'POST',
    url: `${process.env.storefrontApiUrl}/cart/add_diamond`,
    headers: {
      'Content-Type': 'application/vnd.api+json',
      'X-Spree-Order-Token': token,
    },
    data: { diamond_id: id },
  }

  return axios.request<DiamondResponse>(options)
}

type BundleData = {
  items: ({ variant_id: string; quantity: number } | { diamond_id: string })[]
  group_id?: number
}

// This endpoint allow us to create a combined product by adding prop called groupId to the items passed in the body
export const createCompleteRingProduct = async (
  diamondId: string,
  productId: string,
  groupId: number | undefined,
  token: string | undefined
) => {
  let data: BundleData = {
    items: [{ variant_id: productId, quantity: 1 }, { diamond_id: diamondId }],
  }

  if (groupId !== undefined) {
    data = {
      ...data,
      group_id: groupId,
    }
  }

  const options = {
    method: 'POST',
    url: `${process.env.storefrontApiUrl}/cart/add_bundle`,
    headers: {
      'Content-Type': 'application/vnd.api+json',
      'X-Spree-Order-Token': token,
    },
    data: data,
  }

  return axios.request<DiamondResponse>(options)
}
